import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import DojoShell from "@/components/DojoShell";
import ShareContent from "@/components/ShareContent";
import { getShareByToken } from "@/lib/api";

export default function PartageLien() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  const load = () => getShareByToken(token).then(setData).catch(() => { setErr(true); toast.error("Lien invalide ou expiré"); });
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [token]);

  return (
    <DojoShell crumbs={[{ label: "Partage" }]}>
      {err ? <p style={{ color: "var(--text-secondary)" }}>Ce lien de partage est invalide ou a été retiré.</p>
        : !data ? <p style={{ color: "var(--text-secondary)" }}>Chargement…</p>
        : <ShareContent share={data.share} content={data.content} onReload={load} />}
    </DojoShell>
  );
}
